import { Sprite } from "pixi.js";

class Button extends Sprite {
  isButton = true;

  constructor(obj) {
    super();
    this.interactive = true;
    // this.eventMode = 'static';
    this.handler = null;
    this.name = null;
    this.hover = true;

    if (obj.cursor) {
      this.cursor = obj.cursor;
    } else {
      this.cursor = "pointer";
    }
    if (obj.hover !== undefined) {
      this.hover = obj.hover;
    }
    this.handler = obj.handler;
    this.name = obj.name;
    // this.on("pointerdown", this.clickHandler.bind(this));
    this.on(
      window.isMobile || window.isTablet ? "tap" : "click",
      this.clickHandler.bind(this)
    );
    this.on(
      window.isMobile || window.isTablet ? "touchendoutside" : "mouseupoutside",
      this.mouseupoutsideHandler.bind(this)
    );
    if (window.isMobile || window.isTablet) {
    } else {
      this.on("mouseover", this.mouseOverHandler.bind(this));
    }
  }

  mouseOverHandler(e) {
    if (this.hover) {
      window.sm.play({ name: "general_hover_sfx", volume: 0.1 });
    }
  }
  clickHandler(e) {
    if (this.handler) {
      this.handler(this.name);
    }
  }
  mouseDownHandler(e) {}
  mouseUpHandler(e) {}
  mouseupoutsideHandler(e) {}
}

export default Button;
